import { Circle, HStack, VStack, IconButton, Heading, Accordion, Span, Icon, Box } from '@chakra-ui/react';
import { NavLink } from 'react-router-dom';

import { MdMenu } from 'react-icons/md'; // modern
import { MdOutlineSearch } from "react-icons/md";
import { BsTiktok } from 'react-icons/bs';
import { KreozaYouTube } from '@/components/icons/YouTube';
import { routeTo } from '@/router/routeTo';

type SideProps = {
  open: boolean;
  onToggle: () => void;
};

export const Sidebar = ({ open, onToggle }: SideProps) => {
  const Links = [
    {
      title: "YouTube",
      value: 'youtube',
      icon: <KreozaYouTube />,
      links: [
        {
          title: 'Dashboard',
          value: 'dashboard',
          link: routeTo.youtubeRoot(),
        },
        {
          title: 'Comments',
          value: 'comments',
          link: routeTo.youtubeComments(),
        },
        {
          title: 'Analytics',
          value: 'analytics',
          link: routeTo.youtubeAnalytics(),
        },
        {
          title: 'Live Chat',
          value: 'live-chat',
          link: routeTo.youtubeLiveChat(),
        },

      ]
    },
    {
      title: "TikTok",
      value: 'tiktok',
      icon: <BsTiktok/>,
      links: [
        {
          title: 'Dashboard',
          value: 'dashboard',
          link: routeTo.tiktokRoot(),
        },
        {
          title: 'Comments',
          value: 'comments',
          link: routeTo.tiktokComments(),
        },
        {
          title: 'Analytics',
          value: 'analytics',
          link: routeTo.tiktokAnalytics(),
        },
      ]
    },
  ]
  return (
  <VStack align="start" gap={4} p={10} pointerEvents="auto" top={0} left={0}>
    {/* MenuIcon && SearchIcon */}
    <HStack
      top={2}
      left={2}
      >
      <Circle 
        top={2}
        left={2}
        position="fixed"
      >
        <IconButton
          onClick={onToggle} 
          variant="ghost" 
          size="lg"
        >
          <MdMenu />
        </IconButton>
      </Circle>
      
      
      {open && (
        <IconButton
          top={2}
          gap={4}
          position="absolute"
          p={4}
          borderRadius="md"
          zIndex={2}
          right={2}
          variant="ghost"
          size="lg"
        >
          <MdOutlineSearch />
        </IconButton>
      )}
    </HStack>
    { open && (
      <VStack>
        {/* Media Content */}
        <VStack align="start" gap={2} mt={6}>
          <Heading size="md" mb={2}>Media</Heading>
          <Accordion.Root collapsible defaultValue={["b"]} position="relative">
            {Links.map((item, index) => (
              <Accordion.Item key={index} value={item.value}>
                <Box mt={2}>
                  <Accordion.ItemTrigger 
                    display="flex" 
                    alignItems="center" 
                    justifyContent="space-between" 
                    px={3}
                    py={2}
                    borderRadius="md"
                    _hover={{ bg: "sidebar.hover" }}
                    bg="none"
                  >
                    {/* Icon + title */}
                    <HStack gap={2} flex="1" alignItems="center">
                      <Icon fontSize="lg" size="2xl">{item.icon}</Icon>
                      <Span>
                        <Heading as="h4" size="md">
                          {item.title}
                        </Heading>
                      </Span>
                    </HStack>

                    {/* Indicator on the far right */}
                    <Accordion.ItemIndicator flexShrink={0} />
                  </Accordion.ItemTrigger>

                  <Accordion.ItemContent>
                    {item.links.map((link, linkIndex) => (
                      <Accordion.ItemBody key={linkIndex} px={4} py={1}>
                        <Circle w="full" bg="sidebar-bg" px={4} py={2} textAlign="left">
                          <NavLink to={link.link}>
                            <Heading as="h4" size="sm" _hover={{ textDecoration: "underline dashed" }}>
                              {link.title}
                            </Heading>
                          </NavLink>
                        </Circle>
                      </Accordion.ItemBody>
                    ))}
                  </Accordion.ItemContent>
                </Box>
              </Accordion.Item>
            ))}
          </Accordion.Root>
        </VStack>
      </VStack>
    )}
  </VStack>
  );
};